let language = {
    DELIVERY_ORDER_BILLING_ADDRESS: "账单地址:",
    DELIVERY_ORDER_SHIPPING_ADDRESS: "收货地址:",
    DELIVERY_ORDER_STORE_NAME: "店铺名称:",
    DELIVERY_ORDER_TRACKING_NUMBER: "物流单号:",
    DELIVERY_ORDER_DELIVERY_TYPE: "配送类型:",
    DELIVERY_ORDER_DELIVERY_DATE: "配送日期:",
    DELIVERY_ORDER_PAYMENT_TYPE: "支付方式:",
    DELIVERY_ORDER_REMARK: "备注:",
    DELIVERY_ORDER_SOURCE_ORDER: "源订单:",
    DELIVERY_ORDER_PRICE: "价格:",
    DELIVERY_ORDER_WEIGHT: "重量:",
    DELIVERY_ORDER_TOTAL_PRICE: "总价格:",
    DELIVERY_ORDER_TOTAL_WEIGHT: "总重量:",

    // 
    DELIVERY_ORDER_PREVIEW_BTN: "预览",
};

export { language }
